//DoctorForm.jsx
import Typography from '@mui/material/Typography';
import { Avatar, Alert, Button, Grid, Snackbar, styled } from '@mui/material';
import { SimpleCard } from 'app/components';
import { Span } from 'app/components/Typography';
import { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { addDoctor, updateDoctorDetails } from 'app/api-ws/doctor-ws';
import useAuth from 'app/hooks/useAuth';

const TextField = styled(TextValidator)(() => ({
  width: '100%',
  marginBottom: '16px'
}));

const DoctorForm = ({
  doctor,
  setProfileImage,
  profileImage,
  handleCloseDialog,
  handleDialogSubmit
}) => {
  const [doctorName, setDoctorName] = useState({
    firstName: doctor?.doctorName?.firstName || '',
    lastName: doctor?.doctorName?.lastName || ''
  });
  const [email, setEmail] = useState(doctor?.email);
  const [phoneNumber, setPhoneNumber] = useState({
    cell: doctor?.phoneNumber?.cell || '',
    whatsapp: doctor?.phoneNumber?.whatsapp || ''
  });

  const [centerAddress, setCenterAddress] = useState({
    centerName: doctor?.centerAddress?.centerName || '',
    street: doctor?.centerAddress?.street || '',
    locality: doctor?.centerAddress?.locality || '',
    district: doctor?.centerAddress?.district || '',
    state: doctor?.centerAddress?.state || 'Karnataka',
    pincode: doctor?.centerAddress?.pincode || ''
  });
  const [aboutDoctor, setAboutDoctor] = useState({
    qualification: doctor?.aboutDoctor?.qualification || '',
    specialisation: doctor?.aboutDoctor?.specialisation || ''
  });

  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');
  const { user } = useAuth();

  const handleSubmit = (event) => {
    const doctorRequest = {
      doctorName: {
        firstName: doctorName?.firstName,
        lastName: doctorName?.lastName
      },
      email: email,
      password: 'Doctor@123',
      phoneNumber: {
        cell: phoneNumber?.cell,
        whatsapp: phoneNumber?.cell
      },
      refAdminId: user?._id,
      centerAddress: {
        centerName: centerAddress.centerName,
        street: centerAddress.street,
        locality: centerAddress.locality,
        district: centerAddress.district,
        state: centerAddress.state,
        pincode: centerAddress.pincode
      },
      aboutDoctor: {
        qualification: aboutDoctor.qualification,
        specialisation: aboutDoctor.specialisation
      },
      role: 'DOCTOR'
    };

    addDoctor(doctorRequest, user?.authToken)
      .then((res) => {
        console.log(res);
        if (res.data.status === 'success') {
          setSnackBarMessage('Doctor Added Successfully');
          setSnackBarType('success');
          showSnackBar();
          handleDialogSubmit();
        } else {
          setSnackBarMessage('Error in adding Doctor');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in adding Doctor');
        setSnackBarType('error');
        showSnackBar();
      });
    console.log('submitted');
  };

  const updateDoctorSubmit = (event) => {
    const updateDoctorRequest = {
      _id: doctor?._id,
      doctorName: {
        firstName: doctorName?.firstName,
        lastName: doctorName?.lastName
      },

      doctorProfile: profileImage,
      phoneNumber: {
        cell: phoneNumber?.cell,
        whatsapp: phoneNumber?.whatsapp
      },
      centerAddress: {
        centerName: centerAddress?.centerName,
        street: centerAddress?.street,
        locality: centerAddress?.locality,
        district: centerAddress?.district,
        state: centerAddress?.state,
        pincode: centerAddress?.pincode
      },
      aboutDoctor: {
        qualification: aboutDoctor?.qualification,
        specialisation: aboutDoctor?.specialisation
      }
    };
    updateDoctorDetails(updateDoctorRequest, user?.authToken)
      .then((res) => {
        console.log(res.data.statusCode == '200');
        if (res.data.statusCode == '200') {
          setSnackBarMessage('Doctor updated Successfully');
          setSnackBarType('success');
          showSnackBar();
          handleDialogSubmit();
        } else {
          setSnackBarMessage('Error in updating Doctor');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in updating Doctor');
        setSnackBarType('error');
        showSnackBar();
      });
    console.log('submitted');
  };

  function showSnackBar() {
    setOpen(true);
  }
  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result.split(',')[1];
        setProfileImage(base64Data);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <SimpleCard>
        <Avatar
          alt="Clinic"
          src={`data:image/jpeg;base64,${profileImage}`}
          style={{ width: '150px', height: '150px', margin: 'auto' }}
        />
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="contained-button-file"
          type="file"
          onChange={handleImageChange}
        />
        <label htmlFor="contained-button-file">
          <Button variant="contained" component="span" style={{ marginTop: '20px' }}>
            Upload Logo
          </Button>
        </label>
      </SimpleCard>
      {/* <Box py="12px" /> */}

      <ValidatorForm onSubmit={doctor ? updateDoctorSubmit : handleSubmit} onError={() => null}>
        <Typography variant="h6" gutterBottom>
          Personal Details
        </Typography>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <TextField
              type="text"
              name="FirstName"
              id="standard-basic"
              label="First Name"
              variant="outlined"
              fullWidth
              value={doctorName?.firstName}
              onChange={(e) => setDoctorName({ ...doctorName, firstName: e.target.value })}
              errorMessages={['this field is required']}
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="LastName"
              id="standard-basic"
              label="Last Name"
              variant="outlined"
              fullWidth
              value={doctorName.lastName}
              onChange={(e) => setDoctorName({ ...doctorName, lastName: e.target.value })}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="email"
              label="Email"
              variant="outlined"
              fullWidth
              value={email || ''}
              onChange={(val) => setEmail(val.target.value)}
              validators={['required', 'isEmail']}
              errorMessages={['this field is required', 'email is not valid']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="number"
              name="cellNumber"
              id="standard-basic"
              value={phoneNumber.cell}
              onChange={(val) => setPhoneNumber({ ...phoneNumber, cell: val.target.value })}
              label="PhoneNumber"
              validators={['required', 'isNumber', 'matchRegexp:^\\d{10}$']}
              errorMessages={[
                'This field is required',
                'Must be a number',
                'Phone number must be 10 digits'
              ]}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="centerAddress"
              id="standard-basic"
              value={centerAddress.centerName}
              onChange={(val) =>
                setCenterAddress({ ...centerAddress, centerName: val.target.value })
              }
              errorMessages={['this field is required']}
              label="Center Name"
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="StreetAddress"
              id="standard-basic"
              value={centerAddress.street}
              onChange={(val) => setCenterAddress({ ...centerAddress, street: val.target.value })}
              label="Street"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="Locality"
              id="standard-basic"
              value={centerAddress.locality}
              onChange={(val) => setCenterAddress({ ...centerAddress, locality: val.target.value })}
              label="Locality"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="District"
              id="standard-basic"
              value={centerAddress.district}
              onChange={(val) => setCenterAddress({ ...centerAddress, district: val.target.value })}
              label="District"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="State"
              id="standard-basic"
              value={centerAddress.state}
              onChange={(val) => setCenterAddress({ ...centerAddress, state: val.target.value })}
              label="State"
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="number"
              name="Pincode"
              id="standard-basic"
              value={centerAddress.pincode}
              onChange={(val) => setCenterAddress({ ...centerAddress, pincode: val.target.value })}
              errorMessages={['this field is required']}
              label="Pincode"
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="Qualification"
              id="standard-basic"
              value={aboutDoctor.qualification}
              onChange={(val) =>
                setAboutDoctor({ ...aboutDoctor, qualification: val.target.value })
              }
              errorMessages={['this field is required']}
              label="Qualification"
              validators={['required']}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              type="text"
              name="Specialisation"
              id="standard-basic"
              value={aboutDoctor.specialisation}
              onChange={(val) =>
                setAboutDoctor({ ...aboutDoctor, specialisation: val.target.value })
              }
              errorMessages={['this field is required']}
              label="Specialisation"
              validators={['required']}
            />
          </Grid>
        </Grid>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button color="primary" variant="contained" type="submit">
            <Span sx={{ pl: 1, textTransform: 'capitalize' }}>
              {doctor ? 'Save Changes' : 'Add Doctor'}
            </Span>
          </Button>
        </div>
      </ValidatorForm>
    </div>
  );
};

export default DoctorForm;
